import {
  HalfStarIcon,
  Link,
  StarFilledIcon,
  Typography,
} from '@iheartjane/reefer';

import styles from './reviewStars.module.css';

type ReviewStarIconsProps = {
  aggregateRating: number;
};

export function ReviewStarIcons({ aggregateRating }: ReviewStarIconsProps) {
  if (aggregateRating % 1 === 0) {
    return (
      <>
        {[...Array(aggregateRating)].map((_, ind) => (
          <StarFilledIcon
            size="sm"
            key={`star-${ind}`}
            data-testid={`yellow-star-icon-${ind}`}
          />
        ))}
        {[...Array(5 - aggregateRating)].map((_, ind) => (
          <StarFilledIcon
            color="grays-light"
            size="sm"
            key={`star-${ind}`}
            data-testid={`gray-star-icon-${ind}`}
          />
        ))}
      </>
    );
  } else {
    return (
      <>
        {[...Array(Math.floor(aggregateRating))].map((_, ind) => (
          <StarFilledIcon
            size="sm"
            key={`star-${ind}`}
            data-testid={`yellow-star-icon-${ind}`}
          />
        ))}
        <HalfStarIcon size="sm" data-testid="half-star-icon" />
        {[...Array(4 - Math.floor(aggregateRating))].map((_, ind) => (
          <StarFilledIcon
            color="grays-light"
            size="sm"
            key={`star-${5 - ind}`}
            data-testid={`gray-star-icon-${ind}`}
          />
        ))}
      </>
    );
  }
}

type ReviewStarsProps = {
  rating: number;
  reviewCount: number;
  scrollToReviews: () => void;
};

export function ReviewStars({
  rating,
  reviewCount,
  scrollToReviews,
}: ReviewStarsProps) {
  return (
    <div
      className={styles['pdpReviewStarsContainer']}
      data-testid="pdp-review-star"
    >
      <ReviewStarIcons aggregateRating={rating} />

      <Typography color="text-main" ml={4} mr={16}>
        {rating.toFixed(1)}
      </Typography>

      <Link onClick={() => scrollToReviews()}>
        <Typography color="text-main">{reviewCount} ratings</Typography>
      </Link>
    </div>
  );
}
